import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DealsService } from '@app/deals/services/deals.service';
import { MorePage } from '@app/more/more.page';
import { MoreService } from '@app/more/services/more.service';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { UserService } from '@app/user/services';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { NotificationsService } from '@notifications/services/notifications.service';
import { AuthConnectService, PanAppState } from '@panamax/app-state';
import { HeaderService } from '@shared/components/header/header.service';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { AppService } from '@shared/services/app.service';
import { ModalService } from '@shared/services/modal/modal.service';
import { UpcService } from '@shared/services/upc/upc.service';
import { PunchoutService } from '../../../punchout/services/punchout.service';
import { DeliveryStoreService } from '@usf/ngrx-order';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { InviteNewUserService } from '@shared/services/invite-new-user/invite-new-user.service';
import { TranslateService } from '@ngx-translate/core';
import { DivisionPhoneNumberService } from '@shared/services/division-phone-number/division-phone-number.service';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { ToggleNewSearchService } from '@shared/services/toggle-new-search/toggle-new-search.service';
import { PATHS } from '@shared/constants/paths';
import {
  ANALYTICS_ACTIONS,
  MPPAnalyticsConstants,
  MPPTracingConstants,
  MPP_ACTIONS,
  baseMPPTransform,
  buttonClickTransformer,
} from '@usf/ngrx-tools';
import { GuestPageService } from '@shared/services/guest-page/guest-page.service';

@Component({
  selector: 'app-my-business-menu',
  templateUrl: './my-business-menu.page.html',
  styleUrls: ['./my-business-menu.page.scss'],
})
export class MyBusinessMenuPage extends MorePage {
  constructor(
    router: Router,
    store: Store,
    modalController: ModalController,
    panAppState: PanAppState,
    appService: AppService,
    authConnectService: AuthConnectService,
    customerStoreService: CustomerStoreService,
    dealsService: DealsService,
    headerService: HeaderService,
    modalService: ModalService,
    moreService: MoreService,
    navigationHelper: NavigationHelperService,
    notificationsService: NotificationsService,
    punchoutService: PunchoutService,
    upcService: UpcService,
    userService: UserService,
    deliveryStoreService: DeliveryStoreService,
    analyticsService: ProductAnalyticsService,
    inviteNewUserService: InviteNewUserService,
    translateService: TranslateService,
    divisionPhoneNumberService: DivisionPhoneNumberService,
    toggleNewSearchService: ToggleNewSearchService,
    guestPageService: GuestPageService,
  ) {
    super(
      router,
      store,
      modalController,
      panAppState,
      appService,
      authConnectService,
      customerStoreService,
      dealsService,
      headerService,
      modalService,
      moreService,
      navigationHelper,
      notificationsService,
      punchoutService,
      upcService,
      userService,
      deliveryStoreService,
      analyticsService,
      inviteNewUserService,
      translateService,
      divisionPhoneNumberService,
      toggleNewSearchService,
      guestPageService,
    );
    this.pageTitle = PageTitle.myBusiness;
  }

  onMoxeMppClick(): void {
    this.store.dispatch(
      MPP_ACTIONS.clickMPPEntryPoint({
        tracking: {
          tracing: {
            data: {
              traceContext: MPPTracingConstants.clickMPPEntryPoint,
              isEndOfTrace: true,
              isStartOfTrace: true,
              attributes: {
                event: MPPTracingConstants.clickMPPEntryPointEvent,
                spanName: MPPTracingConstants.clickMPPEntryPointSpan,
              },
            },
            transformFunc: baseMPPTransform,
          },
        },
      }),
    );
    this.store.dispatch(
      ANALYTICS_ACTIONS.clickMPPEntryPoint({
        tracking: {
          analytics: {
            data: {
              buttonName: MPPAnalyticsConstants.buttonNameMPP,
              event: MPPAnalyticsConstants.buttonClick,
              capability: MPPAnalyticsConstants.capability,
            },
            transformFunc: buttonClickTransformer,
          },
        },
      }),
    );
    this.navigationHelperService.routeTo(PATHS.MPP);
  }
}
